import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import styles from '../../../styles'
import { makeStyles } from 'tss-react/mui'
import { InputAdornment, styled, TextField } from '@mui/material'

interface CustomTextFieldProps {
	hasvalue: boolean
}

const CustomTextField = styled(TextField)<CustomTextFieldProps>(({ theme, hasvalue }) => ({
	'& .MuiInputLabel-shrink': {
		color: theme.palette.blue.main
	},
	'& label.Mui-focused': {
		color: theme.palette.blue.main
	},
	'& .MuiInputBase-formControl': {
		...styles(theme).text1,
		fontSize: 15,
		color: hasvalue ? theme.palette.blue.main : '#D9D9D9',
		border: `1px solid ${hasvalue ? theme.palette.blue.main : '#D9D9D9'}`,
		fontWeight: 500,
		lineHeight: 1.33,
		borderRadius: 23,
		marginTop: 5,
		padding: '12px 12px 12px 16px'
	},

	'& .MuiTypography-root': {
		color: hasvalue ? theme.palette.blue.main : '#8895a1'
	},

	'& .MuiOutlinedInput-root': {
		'& .MuiOutlinedInput-notchedOutline': {
			border: 'none'
		}
	}
}))

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	textFieldStyle: {
		width: '100%',
		boxSizing: 'border-box',

		'& label': {
			marginBottom: 5,
			...styles(theme).text7,
			fontSize: 11
		},

		'& input': {
			padding: 0
		}
	},
	errorStyle: {
		color: '#B92D00',
		fontSize: '10px'
	},
	errorBorder: {
		border: '1px solid #B92D00'
	},
	defaultTextFieldContainerStyle: {
		width: '100%'
	}
}))

interface AcceptingProps {
	id: string,
	label?: string,
	maxLength?: number,
	endAnorment?: string,
	disabled?: boolean
}

type FormTextFieldInlineProps =
	FieldRenderProps<number>
	& AcceptingProps

const FieldsNombreRechercheForm: React.FC<FormTextFieldInlineProps> = (
	{
		input,
		meta: {
			touched,
			error
		},
		id,
		label,
		maxLength,
		endAnorment,
		disabled = false
	}
) => {
	const { classes, cx } = useStyles()

	const textFieldClass = cx(
		classes.textFieldStyle,
		{
			[classes.errorBorder]: touched && error
		}
	)

	const checkKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === '"') {
			e.preventDefault()
		}
	}

	return (
		<div
			className={cx(classes.defaultTextFieldContainerStyle)}
		>
			<CustomTextField
				id={id}
				onKeyDown={checkKeyDown}
				label={label}
				InputProps={{
					disableUnderline: true,
					endAdornment: <InputAdornment position="end">{endAnorment ?? '€'}</InputAdornment>
				}}
				disabled={disabled}
				InputLabelProps={{
					shrink: true
				}}
				inputProps={{
					maxLength: maxLength
				}}
				className={textFieldClass}
				hasvalue={!!input.value && input.value.toString().length > 0}
				{...input}
			/>

			{touched && error && <span className={classes.errorStyle}>{error}</span>}
		</div>
	)
}

export default FieldsNombreRechercheForm
